import { useState } from "react";
import { FORM_INITIAL_STATE, EDITABLE_STATUSES } from "../constants/formInitialState";

export const useFormState = (labTestId) => {
  const [formData, setFormData] = useState({
    ...FORM_INITIAL_STATE,
    labTestId: labTestId || "",
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleNestedChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: { ...prev[section], [field]: value },
    }));
  };

  const handleTestSymptomChange = (symptom, type, value) => {
    setFormData((prev) => ({
      ...prev,
      testSymptoms: {
        ...prev.testSymptoms,
        [symptom]: { ...prev.testSymptoms[symptom], [type]: value },
      },
    }));
  };

  const handleOthersDescriptionChange = (index, value) => {
    const wordCount = value
      .trim()
      .split(/\s+/)
      .filter((w) => w.length > 0).length;

    setFormData((prev) => {
      const newSymptoms = [...prev.testSymptoms.others.symptoms];
      newSymptoms[index] = { ...newSymptoms[index], description: value, wordCount };
      return {
        ...prev,
        testSymptoms: {
          ...prev.testSymptoms,
          others: { ...prev.testSymptoms.others, symptoms: newSymptoms },
        },
      };
    });
  };

  const handleOthersMinutesChange = (index, value) => {
    setFormData((prev) => {
      const newSymptoms = [...prev.testSymptoms.others.symptoms];
      newSymptoms[index] = { ...newSymptoms[index], minutes: value };
      return {
        ...prev,
        testSymptoms: {
          ...prev.testSymptoms,
          others: { ...prev.testSymptoms.others, symptoms: newSymptoms },
        },
      };
    });
  };

  const addOtherSymptom = () => {
    setFormData((prev) => ({
      ...prev,
      testSymptoms: {
        ...prev.testSymptoms,
        others: {
          ...prev.testSymptoms.others,
          symptoms: [
            ...prev.testSymptoms.others.symptoms,
            { description: "", minutes: "", wordCount: 0 },
          ],
        },
      },
    }));
  };

  const removeOtherSymptom = (index) => {
    setFormData((prev) => {
      const filtered = prev.testSymptoms.others.symptoms.filter((_, i) => i !== index);
      return {
        ...prev,
        testSymptoms: {
          ...prev.testSymptoms,
          others: {
            ...prev.testSymptoms.others,
            symptoms: filtered.length > 0
              ? filtered
              : [{ description: "", minutes: "", wordCount: 0 }],
          },
        },
      };
    });
  };

  const updateAdditionalEmail = (index, value) => {
    setFormData((prev) => {
      const additionalEmails = [...(prev.additionalEmails || [""])];
      additionalEmails[index] = value;
      return { ...prev, additionalEmails };
    });
  };

  const addAdditionalEmail = () => {
    setFormData((prev) => ({
      ...prev,
      additionalEmails: [...(prev.additionalEmails || [""]), ""],
    }));
  };

  const removeAdditionalEmail = (index) => {
    setFormData((prev) => {
      const filtered = (prev.additionalEmails || [""]).filter((_, i) => i !== index);
      return {
        ...prev,
        additionalEmails: filtered.length > 0 ? filtered : [""],
      };
    });
  };

  const isFormEditable = () => EDITABLE_STATUSES.includes(formData.progress);

  return {
    formData,
    setFormData,
    handleInputChange,
    handleNestedChange,
    handleTestSymptomChange,
    handleOthersDescriptionChange,
    handleOthersMinutesChange,
    addOtherSymptom,
    removeOtherSymptom,
    updateAdditionalEmail,
    addAdditionalEmail,
    removeAdditionalEmail,
    isFormEditable,
  };
};
